import PropTypes from 'prop-types';

export const BuyPlanStepProps = {
  locales: PropTypes.object.isRequired,
  temporaryDomain: PropTypes.string.isRequired,
  hostingId: PropTypes.string.isRequired,
};
